export const tvShows = [
  {
    id: "tv-city-within",
    type: "tv",
    title: "城中之城",
    originalTitle: "City Within the City",
    year: 2023,
    genres: ["都市", "剧情"],
    region: "中国大陆",
    director: "黎望",
    cast: ["顾南舟", "宋知微", "程知远"],
    duration: "全 36 集",
    rating: 8.7,
    heat: 9760,
    poster:
      "https://readdy.ai/api/search-image?query=modern%20urban%20drama%20poster%20of%20a%20lone%20businessman%20silhouette%20standing%20before%20a%20wall%20of%20glowing%20skyscraper%20windows%20at%20blue%20hour%2C%20cold%20glass%20and%20steel%20city%2C%20tense%20mood%2C%20deep%20blue%20tones%20with%20warm%20accents%2C%20minimal%20composition&width=600&height=900&seq=poster-city-within&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=wide%20cinematic%20view%20of%20a%20dense%20modern%20city%20skyline%20at%20dusk%20with%20thousands%20of%20lit%20windows%20and%20floating%20low%20clouds%2C%20urban%20drama%20atmosphere%2C%20deep%20blue%20evening%20tones%20with%20warm%20window%20glow&width=1280&height=720&seq=backdrop-city-within&orientation=landscape",
    tagline: "在这座城里，每个人都有自己的城。",
    summary:
      "一家老牌地产集团在两代人的交接中风雨飘摇，一名从底层做起的职业经理人，被卷入资本、家族与理想的漩涡之中。",
    synopsis: [
      "顾南舟是那种从工地一步步走进高层的职业经理人。老董事长突然病倒，集团内部各方势力开始明争暗斗，他被推到台前，成为所有矛盾的焦点。",
      "并购、旧改、资金链断裂……每一次决策都牵动成千上万人的命运。他一边要守住自己最初做地产的理想，一边要在利益与规则之间艰难行走。而城市的每一次生长或停滞，背后都是无数个家庭的故事。",
      "全剧以行业剧的扎实笔触，勾勒大时代下小人物的抉择与坚守。",
    ],
  },
  {
    id: "tv-star-ocean",
    type: "tv",
    title: "星辰大海",
    originalTitle: "Sea of Stars",
    year: 2024,
    genres: ["科幻", "冒险"],
    region: "中国大陆",
    director: "陆星河",
    cast: ["沈鹿", "白薇", "陆星河", "乔亦辰"],
    duration: "全 24 集",
    rating: 8.8,
    heat: 9890,
    poster:
      "https://readdy.ai/api/search-image?query=epic%20sci-fi%20tv%20series%20poster%20of%20a%20crew%20silhouette%20before%20a%20giant%20glowing%20star%20map%20hologram%20inside%20a%20dark%20starship%20bridge%2C%20sense%20of%20wonder%2C%20deep%20indigo%20and%20cyan%20light%2C%20minimal%20elegant%20layout&width=600&height=900&seq=poster-star-ocean&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=wide%20epic%20cinematic%20space%20scene%20of%20a%20fleet%20of%20ships%20sailing%20toward%20a%20brilliant%20distant%20star%20cluster%2C%20vast%20nebula%20backdrop%2C%20sense%20of%20grand%20adventure%2C%20deep%20blue%20and%20gold%20highlights&width=1280&height=720&seq=backdrop-star-ocean&orientation=landscape",
    tagline: "我们要去的，是星星的尽头。",
    summary:
      "人类第一支远航殖民舰队踏上百年星际旅程，船上三代人的命运随船漂流，在抵达未知星系的那一刻，他们必须回答一个关于家的命题。",
    synopsis: [
      "“星辰号”是人类历史上第一支载人远航殖民舰队，载着数千名志愿者驶向数十光年外的宜居星系。船上的人将在旅途中出生、长大、老去，而目的地只在祖辈的讲述里存在。",
      "领航员沈鹿是船上第三代船员，她从出生起就生活在封闭的舰体里。当舰队终于接近目标星系，却发现那里并非先遣探测所描述的乐土。前进还是返航，成了全船人无法回避的抉择。",
      "剧集以恢弘的宇宙想象，讲述关于勇气、代际与“家”重新定义的故事。",
    ],
  },
  {
    id: "tv-flower-other-shore",
    type: "tv",
    title: "花开彼岸",
    originalTitle: "Blossoms on the Other Shore",
    year: 2021,
    genres: ["古装", "爱情"],
    region: "中国大陆",
    director: "温言",
    cast: ["苏晚", "叶清欢", "顾南舟"],
    duration: "全 40 集",
    rating: 8.1,
    heat: 8420,
    poster:
      "https://readdy.ai/api/search-image?query=elegant%20ancient%20chinese%20costume%20romance%20poster%20of%20a%20graceful%20woman%20in%20flowing%20silk%20robes%20amid%20falling%20red%20petals%20by%20a%20moonlit%20pond%2C%20poetic%20atmosphere%2C%20soft%20warm%20gold%20and%20deep%20blue%20tones%2C%20minimal%20layout&width=600&height=900&seq=poster-flower-other-shore&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=wide%20poetic%20cinematic%20view%20of%20an%20ancient%20chinese%20garden%20pavilion%20by%20a%20moonlit%20lotus%20pond%20with%20blossoming%20trees%2C%20mist%2C%20dreamy%20period%20romance%20atmosphere%2C%20soft%20gold%20and%20indigo%20tones&width=1280&height=720&seq=backdrop-flower-other-shore&orientation=landscape",
    tagline: "彼岸花开了，你就会回来。",
    summary:
      "一株传世的彼岸花、两个隔着身份的年轻人，从少年相识到乱世离散，许下跨越十余年的约定。",
    synopsis: [
      "药王谷中，擅长培育奇花的少女与前来求医的世家公子一见如故。彼时谁也没想到，一株罕见的彼岸花，会成为牵动两大家族与一场朝局变动的关键。",
      "身份、误会与战乱，让两人数次擦肩而过。她守着山谷与约定，他扛起家族与责任。十余年间，人世几度变迁，唯有那句“花开再见”始终没有被辜负。",
      "剧集以细腻的情感与考究的古风美术，讲述一段不慕权势、只求相守的古典爱情。",
    ],
  },
  {
    id: "tv-criminal-notes",
    type: "tv",
    title: "刑侦笔记",
    originalTitle: "Criminal Notes",
    year: 2023,
    genres: ["悬疑", "犯罪"],
    region: "中国大陆",
    director: "黎望",
    cast: ["聂无双", "傅斯年", "唐晓棠"],
    duration: "全 30 集",
    rating: 8.6,
    heat: 9310,
    poster:
      "https://readdy.ai/api/search-image?query=gritty%20crime%20drama%20poster%20of%20a%20detective%20holding%20a%20notebook%20under%20harsh%20interrogation%20room%20light%2C%20cold%20blue%20shadows%2C%20rain-streaked%20window%20reflection%2C%20tense%20procedural%20mood%2C%20minimal%20bold%20composition&width=600&height=900&seq=poster-criminal-notes&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=wide%20moody%20cinematic%20view%20of%20a%20night%20city%20investigation%20scene%20with%20police%20lights%20and%20rain%20reflections%20on%20wet%20asphalt%2C%20tense%20crime%20procedural%20atmosphere%2C%20cold%20blue%20with%20amber%20highlights&width=1280&height=720&seq=backdrop-criminal-notes&orientation=landscape",
    tagline: "每一个案发现场，都留着一句没说完的话。",
    summary:
      "市局重案组的一组搭档，用一本代代相传的“刑侦笔记”，串联起十余桩案件背后的隐秘关联。",
    synopsis: [
      "重案组老刑警傅斯年即将退休，他把自己二十年办案积累的笔记交给年轻搭档聂无双。笔记里记的不只是案情，还有每一个被忽略的细节、每一个没能救下的人。",
      "从一桩看似普通的入室案开始，两人发现多起旧案之间存在着若有若无的联系。随着一本笔记被逐页翻过，一个隐藏在城市阴影里的组织逐渐浮出水面。",
      "剧集以写实的刑侦流程与扎实的人物塑造，致敬每一个在黑夜里守着底线的人。",
    ],
  },
  {
    id: "tv-our-ten-years",
    type: "tv",
    title: "我们的十年",
    originalTitle: "Our Ten Years",
    year: 2022,
    genres: ["青春", "成长"],
    region: "中国大陆",
    director: "唐晓棠",
    cast: ["白薇", "乔亦辰", "许砚"],
    duration: "全 28 集",
    rating: 8.3,
    heat: 8640,
    poster:
      "https://readdy.ai/api/search-image?query=nostalgic%20youth%20drama%20poster%20of%20a%20group%20of%20friends%20silhouettes%20on%20a%20school%20sports%20field%20at%20golden%20sunset%2C%20long%20warm%20shadows%2C%20bittersweet%20coming%20of%20age%20mood%2C%20warm%20orange%20and%20soft%20teal%20tones%2C%20minimal%20layout&width=600&height=900&seq=poster-our-ten-years&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=wide%20warm%20nostalgic%20cinematic%20view%20of%20a%20high%20school%20campus%20and%20sports%20field%20at%20sunset%20with%20distant%20students%2C%20golden%20light%2C%20bittersweet%20coming%20of%20age%20atmosphere%2C%20warm%20amber%20tones&width=1280&height=720&seq=backdrop-our-ten-years&orientation=landscape",
    tagline: "十年之后，我们终于学会了告别。",
    summary:
      "四个从高中就形影不离的好友，用十年时间走过毕业、求职、恋爱与分离，见证彼此如何长成当年想成为或不想成为的样子。",
    synopsis: [
      "高三那年，四个性格迥异的朋友约定：无论将来在哪里，十年后都要回到那棵老树下。毕业照拍完，人生的分岔路就此铺开。",
      "有人留在家乡安稳度日，有人北漂打拼屡屡碰壁，有人早早结婚又面临选择，有人始终不肯向现实低头。十年间，他们互相支撑，也互相伤害，在一次次聚散中重新理解友情与成长。",
      "剧集以细腻的群像叙事，讲述一代人共同经历过的青春与迷茫。",
    ],
  },
  {
    id: "tv-white-tower-hospital",
    type: "tv",
    title: "白塔医院",
    originalTitle: "White Tower Hospital",
    year: 2024,
    genres: ["医疗", "职业"],
    region: "中国大陆",
    director: "郑清和",
    cast: ["温言", "程知远", "宋知微", "许砚"],
    duration: "全 32 集",
    rating: 8.5,
    heat: 9050,
    poster:
      "https://readdy.ai/api/search-image?query=medical%20drama%20poster%20of%20a%20surgeon%20in%20green%20scrubs%20standing%20in%20a%20long%20bright%20hospital%20corridor%20at%20dawn%2C%20clean%20cold%20light%2C%20serious%20professional%20mood%2C%20soft%20teal%20and%20white%20with%20warm%20highlights%2C%20minimal%20composition&width=600&height=900&seq=poster-white-tower&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=wide%20clean%20cinematic%20view%20of%20a%20modern%20hospital%20corridor%20at%20early%20morning%20with%20long%20light%20shafts%20and%20a%20distant%20medical%20team%2C%20professional%20calm%20atmosphere%2C%20soft%20blue%20and%20white%20tones&width=1280&height=720&seq=backdrop-white-tower&orientation=landscape",
    tagline: "白塔上的灯，整夜都亮着。",
    summary:
      "从急诊科到手术台，一群医护人员在城市最大的公立医院里，日复一日地与时间赛跑，也与自己的信念对话。",
    synopsis: [
      "白塔医院是这座城市接诊量最大的公立医院，急诊科永远人满为患。新来的住院医师程知远满怀理想，却在第一个夜班就遇上了足以改变他职业生涯的抉择。",
      "带教老师温言是出了名的严格，手术台的每一秒都不容闪失。年轻医生们在高强度的工作中迅速成长，也逐渐理解了“医者”二字背后的重量与无奈。",
      "剧集以大量真实医疗细节与群像故事，展现白大褂之下的人间百态。",
    ],
  },
  {
    id: "tv-mist-chase",
    type: "tv",
    title: "迷雾追凶",
    originalTitle: "Chasing Through the Mist",
    year: 2022,
    genres: ["悬疑", "剧情"],
    region: "中国大陆",
    director: "韩澈",
    cast: ["傅斯年", "白薇", "黎望"],
    duration: "全 26 集",
    rating: 8.4,
    heat: 8790,
    poster:
      "https://readdy.ai/api/search-image?query=atmospheric%20mystery%20drama%20poster%20of%20a%20detective%20figure%20walking%20alone%20into%20thick%20grey%20mist%20on%20a%20forest%20road%20at%20dawn%2C%20tall%20pines%2C%20eerie%20cold%20mood%2C%20muted%20teal%20and%20grey%20tones%20with%20faint%20warm%20light%2C%20minimal%20composition&width=600&height=900&seq=poster-mist-chase&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=wide%20eerie%20cinematic%20view%20of%20a%20dense%20foggy%20pine%20forest%20road%20at%20dawn%20with%20faint%20car%20headlights%2C%20cold%20mysterious%20atmosphere%2C%20muted%20teal%20and%20grey%20tones&width=1280&height=720&seq=backdrop-mist-chase&orientation=landscape",
    tagline: "凶手一直就在雾里，看着我们走来。",
    summary:
      "小镇接连发生失踪案，一名外调而来的女刑警与当地老警察联手调查，却在浓雾般的信息中，一步步逼近自己不愿面对的真相。",
    synopsis: [
      "山区小镇三个月内接连有年轻人失踪，官方定性为意外。女刑警白薇被外调到当地核查线索，发现所有的口供都指向同一片被雾常年笼罩的林子。",
      "老警察黎望在小镇生活了三十年，熟悉每一条路、每一个人。两人从互不信任到不得不合作，逐渐拼凑出一张比想象中更庞大的网。而最关键的那块拼图，恰恰藏在白薇自己的过去里。",
      "剧集以氛围营造与多线叙事见长，是一部考验耐心的慢热悬疑。",
    ],
  },
  {
    id: "tv-jianghu-night-rain",
    type: "tv",
    title: "江湖夜雨",
    originalTitle: "Night Rain of Jianghu",
    year: 2021,
    genres: ["武侠", "古装"],
    region: "中国大陆",
    director: "温言",
    cast: ["顾南舟", "叶清欢", "聂无双", "陆星河"],
    duration: "全 42 集",
    rating: 8.2,
    heat: 8260,
    poster:
      "https://readdy.ai/api/search-image?query=wuxia%20martial%20arts%20drama%20poster%20of%20a%20swordsman%20in%20dark%20flowing%20robes%20standing%20on%20a%20temple%20roof%20in%20pouring%20night%20rain%2C%20drawn%20sword%20glinting%2C%20dramatic%20ink-wash%20mood%2C%20deep%20blue%20and%20silver%20tones%2C%20minimal%20composition&width=600&height=900&seq=poster-jianghu-night-rain&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=wide%20cinematic%20wuxia%20scene%20of%20traditional%20chinese%20temple%20roofs%20and%20bamboo%20forest%20in%20heavy%20night%20rain%20with%20a%20distant%20swordsman%20silhouette%2C%20ink-wash%20mood%2C%20deep%20blue%20and%20silver%20tones&width=1280&height=720&seq=backdrop-jianghu-night-rain&orientation=landscape",
    tagline: "天下之大，何处不是江湖。",
    summary:
      "一个只想归隐的剑客，被一桩旧案重新拖入江湖纷争，在恩怨与道义之间，走完自己最后一程。",
    synopsis: [
      "剑客顾南舟厌倦了厮杀，隐居山野，只求余生清静。可一位故人的意外来访，让一桩尘封多年的武林旧案重新浮出水面。",
      "从江南水乡到塞北荒漠，他一路追查，遇见故交、仇敌与萍水相逢的知己。江湖看似快意，实则处处是人情与算计，而他想要的，不过是一个问心无愧的答案。",
      "剧集以写意的武侠美学与文戏武戏并重，讲述一个关于放下与坚守的江湖故事。",
    ],
  },
  {
    id: "tv-city-belle",
    type: "tv",
    title: "都市丽人",
    originalTitle: "City Belle",
    year: 2023,
    genres: ["都市", "情感"],
    region: "中国大陆",
    director: "宋知微",
    cast: ["白薇", "苏晚", "唐晓棠"],
    duration: "全 34 集",
    rating: 8.0,
    heat: 8130,
    poster:
      "https://readdy.ai/api/search-image?query=stylish%20urban%20drama%20poster%20of%20a%20confident%20young%20woman%20walking%20through%20a%20glossy%20city%20street%20at%20dusk%20with%20neon%20reflections%20on%20wet%20pavement%2C%20modern%20fashion%20mood%2C%20deep%20blue%20and%20warm%20amber%20accents%2C%20minimal%20layout&width=600&height=900&seq=poster-city-belle&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=wide%20glossy%20cinematic%20view%20of%20a%20modern%20city%20street%20at%20dusk%20with%20neon%20signs%20and%20reflections%20on%20wet%20pavement%2C%20urban%20fashion%20atmosphere%2C%20deep%20blue%20with%20warm%20accent%20lights&width=1280&height=720&seq=backdrop-city-belle&orientation=landscape",
    tagline: "穿得体面，才扛得住这座城。",
    summary:
      "三位在时尚与职场打拼的女性，在光鲜的城市表面下，各自面对着事业、友情与感情的考题。",
    synopsis: [
      "白薇是刚升职的时尚杂志主编，苏晚是自立门户的设计师，唐晓棠是在大厂里努力证明自己的新人。三个女人在这座城市里相遇、互助，也难免暗中较劲。",
      "职场的天花板、感情的取舍、舆论的苛责，让她们一次次站在选择的路口。聚光灯下是体面，灯光之外才是真实的生活。",
      "剧集以轻快又不失锋利的方式，讲述都市女性如何为自己而活。",
    ],
  },
  {
    id: "tv-mountain-sea-tales",
    type: "tv",
    title: "山海奇谭",
    originalTitle: "Tales of Mountains and Seas",
    year: 2024,
    genres: ["奇幻", "冒险"],
    region: "中国大陆",
    director: "陆星河",
    cast: ["沈鹿", "叶清欢", "乔亦辰", "温言"],
    duration: "全 20 集",
    rating: 8.6,
    heat: 9220,
    poster:
      "https://readdy.ai/api/search-image?query=fantasy%20adventure%20drama%20poster%20of%20a%20young%20traveler%20facing%20mythical%20glowing%20beasts%20and%20floating%20enchanted%20islands%2C%20ancient%20chinese%20mythology%20imagery%2C%20vivid%20magical%20colors%2C%20deep%20blue%20and%20gold%2C%20rich%20minimal%20composition&width=600&height=900&seq=poster-mountain-sea-tales&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=wide%20fantasy%20cinematic%20landscape%20of%20floating%20enchanted%20islands%20above%20a%20glowing%20sea%20with%20mythical%20creatures%2C%20ancient%20chinese%20mythology%20atmosphere%2C%20vivid%20deep%20blue%20and%20gold%20tones&width=1280&height=720&seq=backdrop-mountain-sea-tales&orientation=landscape",
    tagline: "翻过这座山，山海之外还有山海。",
    summary:
      "少年为寻找失踪的师父踏上旅途，循着一本残缺的《山海图志》，闯入一个神话与现实交叠的奇幻世界。",
    synopsis: [
      "少年沈鹿自幼跟随师父学习辨识奇珍异兽。师父骤然失踪，只留下一本残缺的《山海图志》，以及一句“山海之外，自有山海”。",
      "他背上行囊踏上旅途，一路遇见会说话的灵兽、被诅咒的岛屿与守着秘密的旅人。每解开图志上的一页，世界便多显露出一层真实。",
      "剧集以瑰丽的东方奇幻想象与紧凑的冒险节奏，讲述一个少年如何靠勇气与好奇，找到自己该走的路。",
    ],
  },
];